import { StockQuantityResponse } from '@/src/lib/stock-quantity/types';
import { SingleApiFormat } from '@/src/lib/http/jsonapi/deserializer';

export function getStockQuantityValueFromResponse(response: SingleApiFormat<StockQuantityResponse>) {
  return response.data.attributes.items[0].quantity;
}
